module.exports = __webpack_public_path__ + "static/animeGif-2a1cbf49c94b396e5c6bac98e9a7a02d.gif";